<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div
        class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto"
      >
        <div class="w-full text-right sticky top-0 right-0">
          <button
            aria-label="close"
            class="text-xl text-gray-500"
            @click.prevent="close"
          >
            ×
          </button>
        </div>
        <div class="flex flex-wrap">
          <div
            class="w-full text-left px-3 pb-3 text-purple-700 text-2xl font-bold"
          >
            Subir Imagen o video
          </div>
          <div class="flex flex-col w-full">
            <form
              class="w-full max-w-lg"
              id="levantamientoForm"
              @submit.prevent
            >
              <div>
                <div class="flex flex-wrap -mx-3 pb-3">
                  <div class="w-full px-3 mb-6 md:mb-0">
                    <label
                      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    >
                      Subir archivo
                    </label>
                    <div
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 mb-3 leading-tight focus:outline-none focus:bg-white"
                    >
                      <label
                        for="levantamientoFile"
                        class="flex w-full cursor-pointer -my-2 whitespace-no-wrap"
                      >
                        <span
                          class="bg-gray-900 text-gray-100 py-2 px-4 p rounded-l"
                          >Seleccionar archivo</span
                        >
                        <span class="py-2 px-4 truncate">{{
                          inputFilePlaceholder
                        }}</span>

                        <template v-if="raising.selectType">
                          <template v-if="raising.selectType=='video/mp4'">
                            <input
                              @change="changeLevantamientoFile"
                              class="sr-only"
                              type="file"
                              name="levantamientoFile"
                              id="levantamientoFile"
                              accept="video/mp4"
                            />
                          </template>

                          <template v-else>
                            <input
                              @change="changeLevantamientoFile"
                              class="sr-only"
                              type="file"
                              name="levantamientoFile"
                              id="levantamientoFile"
                              accept="image/png, image/jpeg"
                            />
                          </template>
                        </template>

                        <template v-else>
                          <input
                            @change="changeLevantamientoFile"
                            class="sr-only"
                            type="file"
                            name="levantamientoFile"
                            id="levantamientoFile"
                            accept="image/png, image/jpeg, video/mp4"
                          />
                        </template>

                      </label>
                    </div>
                  </div>
                  <div class="w-full px-3">
                    <img
                      v-if="imageSelected"
                      :src="levantamientoImageUrl"
                      class="h-full w-full object-cover"
                      alt
                    />

                    <video
                      v-if="videoSelected"
                      :src="levantamientoVideoUrl"
                      class="h-full w-full"
                      controls
                    ></video>
                  </div>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                  @click="close()"
                >
                  Cerrar
                </button>
                <button
                  class="ml-2 bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveLevantamiento()"
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Levantamiento guardado correctamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="close()"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error.</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-cdmx-red"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>
<script>
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";

export default {
  name: 'user-raising-new-media-modal',
  data() {
    return {
      fileMimeType: null,
      raising: null,
      inputFilePlaceholder: "Sin archivos seleccionados",
      levantamientoMediaUrl: null,
      imageSelected: false,
      videoSelected: false,
      errors: {
        file_extension: false,
        codeError: "Ha ocurrido un error",
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean,
    }
  },
  mounted() {
    EventBus.$on("newMediaModal", this.setData);
  },
  components: {
    AlertDialog,
  },
  methods: {
    reset: function () {
      this.fileMimeType = null;
      this.raising = null;
      this.imageSelected = false;
      this.videoSelected = false;
      this.inputFilePlaceholder = "Sin archivos seleccionados";
      this.errors = {
        file_extension: false,
        codeError: "Ha ocurrido un error",
      };
      this.showingSuccess = false;
      this.showingError = false;
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    setData(raising) {
      this.raising = Object.assign({}, raising);
    },
    saveLevantamiento() {
      if (document.getElementById("levantamientoFile").value !== "") {
        this.$root.$emit("showLoading");
        const form = document.getElementById("levantamientoForm");
        const formMediaData = new FormData(form);
        const levantamientoFile = formMediaData.get("levantamientoFile");
        // const mediaFilename =
        //   localStorage.getItem("user_id") + "_" + this.inputFilePlaceholder;
        const newDate = new Date()
        const mediaFilename = localStorage.getItem("user_id") + "_" + newDate.getTime()+this.fileMimeType;

        let levantamientoId = this.raising.id
        //response.data.levantamiento_id;

        const formData = new FormData();
        formData.append("id", levantamientoId);
        formData.append(
          "levantamientoFile",
          levantamientoFile,
          mediaFilename
        );

        this.axios
          .post("../apidev/levantamientos/media", formData, this.config)
          .then((response) => {
            this.$root.$emit("hideLoading");
            this.$emit('updateImage', {
              'file_path': response.data.file_path,
              'file_type': response.data.file_type,
            });
            this.showingSuccess = true;
            this.close();
          })
          .catch((error) => {
            if (
              error.response.status == 400 ||
              error.response.status == 401
            ) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.$root.$emit("hideLoading");
          });
      } else {
        this.close();
      }
    },
    changeLevantamientoFile(event) {
      const file = event.target.files[0];
      this.inputFilePlaceholder = file.name;
      const fileMimeType = this.checkMimeType(file);

      if (fileMimeType === "") {
        this.errors.file_extension = true;
        this.levantamientoMediaUrl = this.srcUrl + "/null";
      } else {
        if (fileMimeType === ".mp4") {
          this.errors.file_extension = false;
          this.levantamientoVideoUrl = URL.createObjectURL(file);
          this.videoSelected = true;
          this.imageSelected = false;
        } else {
          let image = new Image();
          image.src = URL.createObjectURL(file);
          image.onload = () => {
            this.errors.file_extension = false;
            this.levantamientoImageUrl = URL.createObjectURL(file);
            this.imageSelected = true;
            this.videoSelected = false;
          };
        }
      }
      this.fileMimeType = fileMimeType;
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        case "video/mp4":
          mimeType = ".mp4";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
